module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', {
    staticClass: "panel-title"
  }, [_vm._v("Output")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Price",
      "id": "resultTypePricesRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Price")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Price")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Prices")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Quantity",
      "id": "resultTypeQuantitiesRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Quantity")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Quantity")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Quantities")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Both",
      "id": "resultTypeBothRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Both")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Both")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Both")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "New Capacity Additions",
      "id": "resultTypeNewCapAddRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "New Capacity Additions")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "New Capacity Additions")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Capacity Additions")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Resource Curve",
      "id": "resultTypeResourceCurveRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Resource Curve")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Resource Curve")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Resource Curve")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Capital Cost Curve",
      "id": "resultTypeCapCostCurveRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Capital Cost Curve")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Capital Cost Curve")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Capital Cost Curve")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Operating Cost Curve",
      "id": "resultTypeOpCostCurveRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Operating Cost Curve")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Operating Cost Curve")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Operating Cost Curve")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Proved Reserves Production by Vintage"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Proved Reserves Production by Vintage")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Proved Reserves Production by Vintage")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Proved Reserves Production by Vintage")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Levelized Marginal Cost"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Levelized Marginal Cost")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Levelized Marginal Cost")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Levelized Marginal Cost")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Supply by Levelized Cost"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Supply by Levelized Cost")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Supply by Levelized Cost")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Supply by Levelized Cost")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Volume Constraints"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Volume Constraints")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Volume Constraints")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Volume Constraints")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Capacity Usage"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Capacity Usage")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Capacity Usage")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Capacity Usage")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Marginal Summary"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Marginal Summary")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Marginal Summary")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Marginal Summary")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Supply Curve"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Supply Curve")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Supply Curve")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Supply Stack")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Input Stack"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Input Stack")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Input Stack")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Input Stack")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Hub Supply Stack"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Hub Supply Stack")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Hub Supply Stack")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Hub Supply Stack")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Node Data"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Node Data")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Node Data")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Node Data")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.resultType),
      expression: "value.reportParams.resultType"
    }],
    attrs: {
      "type": "radio",
      "value": "Demand Curve"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.resultType, "Demand Curve")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "resultType", "Demand Curve")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Demand Curve")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', {
    staticClass: "panel-title"
  }, [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "reportNameEdit"
    }
  }, [_vm._v("Report Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportName),
      expression: "value.reportName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "reportNameEdit",
      "required": "",
      "placeholder": "Enter report name"
    },
    domProps: {
      "value": (_vm.value.reportName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "reportName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.isGeographic),
      expression: "value.reportParams.isGeographic"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "isGeographicCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.reportParams.isGeographic) ? _vm._i(_vm.value.reportParams.isGeographic, null) > -1 : (_vm.value.reportParams.isGeographic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.reportParams.isGeographic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value.reportParams, "isGeographic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value.reportParams, "isGeographic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value.reportParams, "isGeographic", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "isGeographicCheckbox"
    }
  }, [_vm._v("\n                                Geographic\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interpolateResults),
      expression: "interpolateResults"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "interpolateResultsCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.interpolateResults) ? _vm._i(_vm.interpolateResults, null) > -1 : (_vm.interpolateResults)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.interpolateResults,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.interpolateResults = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.interpolateResults = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.interpolateResults = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "interpolateResultsCheckbox"
    }
  }, [_vm._v("\n                                Interpolate missing timepoints\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includePriceDifferential),
      expression: "includePriceDifferential"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": !_vm.isLinkDataResultType(_vm.value.reportParams.resultType),
      "type": "checkbox",
      "id": "includePriceDifferentialCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includePriceDifferential) ? _vm._i(_vm.includePriceDifferential, null) > -1 : (_vm.includePriceDifferential)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includePriceDifferential,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includePriceDifferential = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includePriceDifferential = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includePriceDifferential = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "includePriceDifferentialCheckbox"
    }
  }, [_vm._v("\n                                Include price differential\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeCapAddDisabledNodes),
      expression: "includeCapAddDisabledNodes"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.value.reportParams.resultType !== "New Capacity Additions",
      "type": "checkbox",
      "id": "includeCapAddDisabledNodesCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeCapAddDisabledNodes) ? _vm._i(_vm.includeCapAddDisabledNodes, null) > -1 : (_vm.includeCapAddDisabledNodes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeCapAddDisabledNodes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeCapAddDisabledNodes = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeCapAddDisabledNodes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeCapAddDisabledNodes = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "includeCapAddDisabledNodesCheckbox"
    }
  }, [_vm._v("\n                                Include Cap Add disabled nodes\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', {
    staticClass: "panel-title"
  }, [_vm._v("Node Filter")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sector"
    }
  }, [_vm._v(" Node Search")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "sector",
      "autocomplete": "new-password",
      "preselect": "",
      "type": "text",
      "required": "",
      "placeholder": "Enter node or sector"
    }
  }), _vm._v(" "), _c('uiv-typeahead', {
    attrs: {
      "target": "#sector",
      "async-function": _vm.sectorSearchFunction
    },
    model: {
      value: (_vm.value.reportParams.sector),
      callback: function($$v) {
        _vm.$set(_vm.value.reportParams, "sector", $$v)
      },
      expression: "value.reportParams.sector"
    }
  })], 1), _vm._v(" "), (_vm.nodeTypesList) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "nodeTypesEdit"
    }
  }, [_vm._v("Node Types")]), _vm._v(" "), _c('div', [_c('uiv-multi-select', {
    attrs: {
      "stye": "width:100%",
      "options": _vm.nodeTypesList,
      "label-key": "label",
      "label-value": "name",
      "id": "nodeTypesEdit"
    },
    model: {
      value: (_vm.value.reportParams.nodeTypes),
      callback: function($$v) {
        _vm.$set(_vm.value.reportParams, "nodeTypes", $$v)
      },
      expression: "value.reportParams.nodeTypes"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.value.reportParams.resultType === 'Supply by Levelized Cost') ? _c('div', [_c('label', {
    attrs: {
      "for": "time-point",
      "id": "queryStringLabel"
    }
  }, [_vm._v("Time Point")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.queryString),
      expression: "value.reportParams.queryString"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "time-point"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value.reportParams, "queryString", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.timePointLookup), function(lookup) {
    return _c('option', [_vm._v("\n                                        " + _vm._s(lookup) + "\n                                    ")])
  }), 0)]) : (_vm.value.reportParams.resultType === 'Node Data') ? _c('div', [_c('label', {
    attrs: {
      "for": "queryStringEdit"
    }
  }, [_vm._v("Variable Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.queryString),
      expression: "value.reportParams.queryString"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "queryStringEdit",
      "autocomplete": "new-password",
      "preselect": "",
      "type": "text",
      "required": "",
      "placeholder": "Select variable"
    },
    domProps: {
      "value": (_vm.value.reportParams.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.reportParams, "queryString", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('uiv-typeahead', {
    attrs: {
      "target": "#queryStringEdit",
      "async-function": _vm.variableSearchFunction
    },
    model: {
      value: (_vm.value.reportParams.queryString),
      callback: function($$v) {
        _vm.$set(_vm.value.reportParams, "queryString", $$v)
      },
      expression: "value.reportParams.queryString"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "linkDirectionFormGroup"
    }
  }, [_vm._v("Link Direction")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "linkDirectionFormGroup"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.direction),
      expression: "value.reportParams.direction"
    }],
    attrs: {
      "type": "radio",
      "value": "Input"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.direction, "Input")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "direction", "Input")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Input")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.direction),
      expression: "value.reportParams.direction"
    }],
    attrs: {
      "type": "radio",
      "value": "Output"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.direction, "Output")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "direction", "Output")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Output")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.direction),
      expression: "value.reportParams.direction"
    }],
    attrs: {
      "type": "radio",
      "value": "Both"
    },
    domProps: {
      "checked": _vm._q(_vm.value.reportParams.direction, "Both")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value.reportParams, "direction", "Both")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Both")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', {
    staticClass: "panel-title"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group tagEditorFormGroup"
  }, [_c('label', {
    attrs: {
      "for": "reportEditorTagsInput"
    }
  }, [_vm._v("Node Tags Search")]), _vm._v(" "), _c('vue-tags-input', {
    attrs: {
      "id": "reportEditorTagsInput",
      "placeholder": "Add tag",
      "tags": _vm.tags,
      "autocomplete-items": _vm.nodeTagAutocompleteItems
    },
    on: {
      "tags-changed": _vm.onTagsChanged
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group tagEditorFormGroup"
  }, [_c('label', {
    attrs: {
      "for": "tagsInput"
    }
  }, [_vm._v("Node Exclude Tags Search")]), _vm._v(" "), _c('vue-tags-input', {
    attrs: {
      "id": "tagsInput",
      "placeholder": "Add tag",
      "tags": _vm.excludeTags,
      "autocomplete-items": _vm.nodeTagAutocompleteItems
    },
    on: {
      "tags-changed": _vm.onExcludeTagsChanged
    },
    model: {
      value: (_vm.excludeTag),
      callback: function($$v) {
        _vm.excludeTag = $$v
      },
      expression: "excludeTag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tag Filter Options")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagAndOr),
      expression: "tagAndOr"
    }],
    attrs: {
      "type": "radio",
      "value": "or"
    },
    domProps: {
      "checked": _vm._q(_vm.tagAndOr, "or")
    },
    on: {
      "change": function($event) {
        _vm.tagAndOr = "or"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Node must match any tag (OR)")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagAndOr),
      expression: "tagAndOr"
    }],
    attrs: {
      "type": "radio",
      "value": "and"
    },
    domProps: {
      "checked": _vm._q(_vm.tagAndOr, "and")
    },
    on: {
      "change": function($event) {
        _vm.tagAndOr = "and"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Node must match all tags (AND)")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', {
    staticClass: "panel-title"
  }, [_vm._v("Scenarios")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.reportParams.includeAllScenarios),
      expression: "value.reportParams.includeAllScenarios"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "includeAllScenariosCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.reportParams.includeAllScenarios) ? _vm._i(_vm.value.reportParams.includeAllScenarios, null) > -1 : (_vm.value.reportParams.includeAllScenarios)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.reportParams.includeAllScenarios,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value.reportParams, "includeAllScenarios", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value.reportParams, "includeAllScenarios", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value.reportParams, "includeAllScenarios", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "includeAllScenariosCheckbox"
    }
  }, [_vm._v("\n                                Include all scenarios\n                            ")])]), _vm._v(" "), (_vm.value.modelInfo) ? _c('div', [_c('uiv-multi-select', {
    attrs: {
      "stye": "width:100%",
      "options": _vm.scenarioNamesSelection,
      "disabled": _vm.value.reportParams.includeAllScenarios,
      "label-key": "label",
      "label-value": "name",
      "id": "scenarioNamesSelect"
    },
    model: {
      value: (_vm.value.reportParams.scenarioNames),
      callback: function($$v) {
        _vm.$set(_vm.value.reportParams, "scenarioNames", $$v)
      },
      expression: "value.reportParams.scenarioNames"
    }
  })], 1) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSaveClick
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4187654c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4187654c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/report-editor-dialog/report-editor-dialog.vue.html
// module id = 1097
// module chunks = 0